import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoEmpresa, cadastrarTipoEmpresa, alterarTipoEmpresa, excluirTipoEmpresa } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var TiposEmpresasEditar = function () {
    var services = {
        getItem: getTipoEmpresa,
        cadastrarItem: cadastrarTipoEmpresa,
        alterarItem: alterarTipoEmpresa,
        excluirItem: excluirTipoEmpresa,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.CC_TIPOS_EMPRESAS, paginaPermissao: FUNCIONALIDADES.CC_TIPOS_EMPRESAS, rota: ROUTES.CC_TIPOS_EMPRESAS, services: services });
};
export default TiposEmpresasEditar;
